export enum SocialRoute {
  Connect = 'connect',
  Post = 'post',
  DeletePost = 'delete-post',
  PostComments = 'post-comments',
  Story = 'story',
}
